var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNegativeSceptical = function SvgNegativeSceptical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 270 270"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".negative_sceptical_svg__cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:13.15px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h270v270H0z",
    id: "negative_sceptical_svg__Hidden_backgroun",
    "data-name": "Hidden backgroun"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "negative_sceptical_svg__Graphic"
  }, /*#__PURE__*/React.createElement("path", {
    className: "negative_sceptical_svg__cls-2",
    d: "M120.35 102.82c-5.83-12.5-25-15.48-33.33-4.53M147.75 110.06l30.95-7.92"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "negative_sceptical_svg__cls-2",
    cx: 167.2,
    cy: 150.65,
    r: 21.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "negative_sceptical_svg__cls-2",
    cx: 98.8,
    cy: 150.65,
    r: 21.95
  }))));
};
export default SvgNegativeSceptical;